import { useGrowthBookFeature } from 'context/growthbook-context'
import { growthbookFeatures } from 'utils/growthbook'

import { ApplePay as ApplePayOld } from './apple-pay-old'
import { ApplePay as ApplePayNew } from './apple-pay-new'

interface ApplePayProps {
  className?: string
  source?: string
  checkoutSuccessSource: string
  blacklistedPaymentMethod?: boolean
}

export const ApplePay = (props: ApplePayProps) => {
  const applePayFeature = useGrowthBookFeature(
    growthbookFeatures.APPLE_PAY_NEW_CONFIGURATION,
  )

  const Component = applePayFeature?.isEnabled ? ApplePayNew : ApplePayOld
  return <Component {...props} />
}
